import punycode from "punycode";
import React, { Component } from "react";
import ReactLinkify from "react-linkify";
// @ts-ignore
import { handlePaymentWindow, isSocialMobileApp } from "../../../../customise/Utils";
import CopyLinkPop from "../../../../customise/custom/components/CopyLinkPop";
// END
export default class Linkify extends Component {
    /**
     * Implements {@Component#render}.
     *
     * @inheritdoc
     */
    // CUSTOM
    constructor(props) {
        super(props);
        this.handleClick = (link, decoratedHref) => {
            const isSocialApp = isSocialMobileApp() ? true : false;
            if (isSocialApp) {
                this.setState({
                    link: decoratedHref,
                    openModal: true,
                    isCopied: false,
                });
            }
            else {
                handlePaymentWindow(decoratedHref, "_blank");
            }
        };
        this.state = {
            link: "",
            openModal: false,
        };
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.state.openModal &&
                React.createElement(CopyLinkPop, { link: this.state.link, isCopied: this.state.isCopied, copyUrl: () => this.setState({ isCopied: true }), handleConfirmAction: (type) => this.setState({ link: "", openModal: false }) }),
            React.createElement(ReactLinkify, { componentDecorator: (decoratedHref, decoratedText, key) => this._componentDecorator(decoratedHref, decoratedText, key, this.handleClick) }, this.props.children)));
    }
    /**
     * Implements a component decorator for react-linkify.
     *
     * @param {string} decoratedHref - The href src.
     * @param {string} decoratedText - The link text.
     * @param {string} key - The component key.
     * @returns {React$Node}
     */
    _componentDecorator(decoratedHref, decoratedText, key, handleClick) {
        return (React.createElement("a", { href: "#", key: key, rel: "noopener noreferrer", target: "_blank", onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                handleClick(punycode.toASCII(decoratedText), decoratedHref);
            } }, punycode.toASCII(decoratedText)));
    }
}
// END
